import {useEffect} from 'react'
import {useAuth} from '../stores/AuthStore'

export const SessionRefresher = (): null => {
  const {handleRefreshSession, useIdpAuthentication} = useAuth()

  // Since the only endpoint that accepts an access_token is the exchange endpoint we cannot rely on services to return a 401 to trigger a refresh.
  // We need to refresh the token manually on a timer near the expiration of the token to get new tokens.
  useEffect(() => {
    if (useIdpAuthentication) {
      const interval = setInterval(() => {
        handleRefreshSession()
      }, 60 * 60 * 1000) // 60 minutes - TODO: make this configurable based on token expiration

      return () => {
        clearInterval(interval)
      }
    }
    return undefined
  }, [useIdpAuthentication, handleRefreshSession])

  return null
}
